import{i as o}from"./implementation.js";var t=o,i=Function.prototype.bind||t;export{i as f};
//# sourceMappingURL=index.js.map
